import clsx from "clsx"
import { FC } from "react"
import { useGame } from "@/providers/GameProvider"
import {
  ActiveEffects,
  Separator,
  UserInfo,
  UserRuneBalance,
  UserSpeedBonus
} from ".."
import styles from "./GameSidePlayer.module.scss"

export const GameSidePlayer: FC = () => {
  const { player, playerInfo, playerStatistics, playerName } = useGame()

  return (
    <div className={clsx(styles.GameSidePlayer)}>
      <ActiveEffects playerId={player?.player} />
      <Separator styleType={1} />
      <UserSpeedBonus speedBonus={player?.speedBonus} />
      <Separator styleType={2} />
      <UserRuneBalance
        speed={{
          value: player?.speed,
          deltaValue: player?.deltaSpeed
        }}
        luck={{
          value: player?.luck,
          deltaValue: player?.deltaLuck
        }}
        stamina={{
          value: player?.stamina,
          deltaValue: player?.deltaStamina
        }}
      />
      <Separator styleType={1} />
      <UserInfo
        playerInfo={playerInfo}
        playerStatistics={playerStatistics}
        name={playerName}
      />
      {/* {isDevMode && (
        <div className={styles.DebugPlayersStats}>
          <DebugPlayersStats playerState={player} />
        </div>
      )} */}
    </div>
  )
}
